import { RichText } from "@wordpress/block-editor";
import { BlockSaveProps } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import classnames from "classnames";
import { escape } from "lodash";
import React from "react";
import "../assets/sass/blocks/heading/style.scss";

const Save: React.ComponentType<BlockSaveProps<any>> = (props) => {
	const {
		className,
		attributes: {
			enableSubHeading,
			label,
			text,
			cssID,
			typography,
			subHeadingTypography,

			clientId,
			markup,

			headingLayout1AdvancedStyle,
			headingLayout2AdvancedStyle,
			headingLayout3AdvancedStyle,
			headingLayout4AdvancedStyle,
			headingLayout5AdvancedStyle,
			headingLayout6AdvancedStyle,
			headingLayout7AdvancedStyle,
			headingLayout8AdvancedStyle,
			headingLayout9AdvancedStyle,
			headingLayout,

			size,
			hideOnDesktop,
		},
	} = props;

	const classNames = classnames(
		`mzb-heading mzb-heading-${clientId} mzb-${headingLayout}`,
		size && `is-${size}`,
		className,
		hideOnDesktop && "magazine-blocks-hide-on-desktop",
		{
			[`mzb-${headingLayout1AdvancedStyle}`]:
				headingLayout === `heading-layout-1`,
			[`mzb-${headingLayout2AdvancedStyle}`]:
				headingLayout === `heading-layout-2`,
			[`mzb-${headingLayout3AdvancedStyle}`]:
				headingLayout === `heading-layout-3`,
			[`mzb-${headingLayout4AdvancedStyle}`]:
				headingLayout === `heading-layout-4`,
			[`mzb-${headingLayout5AdvancedStyle}`]:
				headingLayout === `heading-layout-5`,
			[`mzb-${headingLayout6AdvancedStyle}`]:
				headingLayout === `heading-layout-6`,
			[`mzb-${headingLayout7AdvancedStyle}`]:
				headingLayout === `heading-layout-7`,
			[`mzb-${headingLayout8AdvancedStyle}`]:
				headingLayout === `heading-layout-8`,
			[`mzb-${headingLayout9AdvancedStyle}`]:
				headingLayout === `heading-layout-9`,
		}
	);

	return (
		<Fragment>
			<div className={classNames}>
				<div className="mzb-heading-inner mzb-post-heading">
					<RichText.Content
						id={cssID ? cssID : null}
						className={`mzb-heading-text ${typography?._className}`}
						tagName={markup}
						placeholder={__("This is heading", "magazine-blocks")}
						value={text}
					/>
				</div>

				{enableSubHeading && (
					<div className="mzb-sub-heading">
						<RichText.Content
							id={cssID ? cssID : null}
							className={`${subHeadingTypography?._className}`}
							tagName="p"
							value={escape(label)}
						/>
					</div>
				)}
			</div>
		</Fragment>
	);
};

export default Save;
